module.exports = __webpack_public_path__ + "images/category_lp/furniture/assessment_achievements/5_fb45d00ac31541ad87abc70c1b82bc44.png";